import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { toast } from "react-toastify";
import { Messages } from 'primereact/messages';
import { Container, Button, Row, Col, OverlayTrigger, Tooltip, Form, Card } from "react-bootstrap";
import { ContentHeader, ContentBody, CardBody } from "../styles"
import Error from "../../../../../../../components/Error";
import { Modal } from "../../../../../../../components/modal";


import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { MdOutlineContentCopy, MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md";
import { formatReal } from '../../../../../../../../helpers';
import { NEW_WITHDRAWAL_STEPS } from "../../../../../../../@enums";
import { colors } from "../../../../../../../../theme/theme";
import { confirmPassword, newWithdrawl } from "../../../../../../../services/manager/partner/withdrawl.service";

const validationSchema = Yup.object({
  invoice: Yup.mixed().nullable().required("Adicione uma nota fiscal para prosseguir"),
}).required();

const validationSchemaPassword = Yup.object({
  password: Yup.string().required("Este campo é obrigatório"),
}).required();

export const ConfirmWithdrawal = (props: any): JSX.Element => {
  const history = useHistory();
  const { t: translation } = useTranslation();
  const { balance, withdrawalValue, account, setIndexStep } = props;
  const { handleSubmit, setValue, clearErrors, formState: { errors: errors }} = useForm({ resolver: yupResolver(validationSchema) });
  const { register: registerPassword, handleSubmit: handleSubmitPassword, formState: { errors: errorsPassword } } = useForm({ resolver: yupResolver(validationSchemaPassword) });

  const invoiceRef = useRef<any>(null);
  const fileInput = useRef<any>(null);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [showModalPassword, setShowModalPassword] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>();

  const handleChangePhoto = (e: any) => {
    invoiceRef.current.clear();
    setTimeout(() => {
      setValue('invoice', e.target.files[0])
      clearErrors('invoice')
      invoiceRef.current.show({
        severity: 'info', sticky: true, content: (
          <div className="">{e.target.files[0].name}</div>
        )
      });
    }, 170)
  };

  const handleCopyButton = (itemToCopy: any) => {
    if (itemToCopy === 'agency') {
      navigator.clipboard.writeText(account.agency)
      toast.success('Agência copiada!', { autoClose: 1500 });
    } else if (itemToCopy === 'pix') {
      navigator.clipboard.writeText(account.pix)
      toast.success('Chave PIX copiada!', { autoClose: 1500 });
    } else {
      navigator.clipboard.writeText(account.account)
      toast.success('Conta copiada!', { autoClose: 1500 });
    }
  }

  const onSubmit = (_formData: any) => {
    setFormData(_formData);
    setShowModalPassword(true);
  };

  const onSubmitPassword = (formPassword: any) => {
    setLoadingModal(true)
    confirmPassword(formPassword.password).then((response) => {
      let obj = {
        account_bank: account.id,
        value: withdrawalValue,
        file: formData.invoice,
        type: 2,
      }
      newWithdrawl(obj).then((res) => {
        toast.success('Retirada solicitada com sucesso!')
        history.push('/manager/partner/withdrawal')
        setLoadingModal(false)
      }).catch((err: any) => {
        toast.error(err.res.data.message, {autoClose: 8000})
        setLoadingModal(false)
      });
    }).catch((err: any) => {
      toast.error(err.res.data.message)
      setLoadingModal(false)
    });
  }
  
  return (
    <Container fluid>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ContentHeader>
          <Row>
            <Col>
              <div className="title">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{translation('back')}</Tooltip>}
                >
                  <span>
                    <HiOutlineArrowCircleLeft className="mr-1 mb-1 cursor-pointer" onClick={() => setIndexStep(NEW_WITHDRAWAL_STEPS.requestWithdrawal)}/>                          
                  </span>
                </OverlayTrigger>
                {translation('manager.withdrawal.request')}
              </div>
            </Col>
            <Col className="text-end">
              <Button className="mb-1" type="submit" disabled={false}>
                {translation('manager.withdrawal.finish')}
              </Button>
            </Col>
          </Row>
        </ContentHeader>
        <ContentBody>
          <Row>
            <h5 className="mt-4 text-black"><b>{translation('manager.withdrawal.withdrawalValueSelected')}</b>: <b>R$ {formatReal(withdrawalValue.toFixed(2))}</b></h5>
            <p>
              {translation('manager.withdrawal.balanceAvailableAfter')}: &nbsp;
              <span className="text-green-dstore">
                <b>R$ {formatReal(balance.toFixed(2))}</b>
              </span>
            </p>
            
            <Col md={12} xl={8} xxl={5}>
              <Card style={{ borderRadius: '8px', border: '0.5px solid #efefef', filter: 'drop-shadow(0px 2px 8px rgba(51, 51, 51, 0.15))' }}>
                <CardBody>
                  <h6 className="mt-2 mb-4"><b>{translation('manager.withdrawal.accountData')}</b></h6>
                  <p>{translation('manager.withdrawal.bank')}: {account.bank_name}</p>
                  <Row>
                    <Col md={6}>
                      <Row>
                        <Col xs={7}>
                          <p className="mb-1"><b>{translation('manager.withdrawal.agency')}:</b> {account.agency}</p>
                          <p><b>{translation('manager.withdrawal.account')}:</b> {account.account}</p>
                        </Col>
                        <Col xs={5}>
                          <OverlayTrigger placement="top" overlay={<Tooltip>{translation('manager.withdrawal.copyAccount')}</Tooltip>}>
                            <span className="cursor-pointer">
                              <MdOutlineContentCopy onClick={() => handleCopyButton('agency')}/> <br/>
                            </span>
                          </OverlayTrigger>

                          <OverlayTrigger placement="top" overlay={<Tooltip>{translation('manager.withdrawal.copyAgency')}</Tooltip>}>
                            <span className="cursor-pointer">
                              <MdOutlineContentCopy onClick={() => handleCopyButton('account')}/>
                            </span>
                          </OverlayTrigger>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <p className="mb-1"><b>{translation('manager.withdrawal.accountType')}:</b> {account.account_type === 1 ? "Poupança" : "Corrente"}</p>
                      <Row>
                        <Col xs={10}>
                          <p><b>{translation('manager.withdrawal.pixKey')}:</b> {account.pix ? account.pix : 'Não Informado'}</p>
                        </Col>
                        {
                          account.pix &&
                          <Col xs={2} className="p-0">
                            <OverlayTrigger placement="top" overlay={<Tooltip>{translation('manager.withdrawal.copyPix')}</Tooltip>}>
                              <span className="cursor-pointer">
                                <MdOutlineContentCopy onClick={() => handleCopyButton('pix')}/>
                              </span>
                            </OverlayTrigger>
                          </Col>
                        }
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <h6 className="mb-3 mt-3 text-black"><b>{translation('manager.withdrawal.addInvoices')}</b> <span className="text-dark-grey">(Obrigatório)</span></h6>
            <div><Button variant="outline-primary" onClick={() => fileInput?.current.click()}>{translation('manager.button.add')}</Button></div>
            
            <Form.Group className="">
              <Form.Control ref={fileInput} className="d-none" type="file" accept=".png,.jpg,.jpeg,.pdf" name="invoice" onChange={(e: any) => handleChangePhoto(e)}/>
            </Form.Group>

            <Col xs={12} md={6} xl={4}>
              <Messages ref={invoiceRef} onRemove={() => setValue('invoice', null)} />
            </Col>

            {errors.invoice ? (<div className="w-100"> <Error>{errors.invoice?.message}</Error> </div>) : ""}
          </Row>
        </ContentBody>
      </Form>
      
      <Modal 
        headerTitle="Aviso" 
        submitButtonText={translation('manager.user.confirm')} 
        show={showModalPassword} 
        onHide={() => setShowModalPassword(false)}
        onSubmit={handleSubmitPassword(onSubmitPassword)}
        variant="confirm-modal-default"
        hasDefaultIcon={false}
        loading={loadingModal}
      >
        <Form style={{ textAlign: 'left'}}>
          <h6 className="mb-3 text-black text-center">{translation('manager.withdrawal.typePassword')}</h6>
          <Form.Group className="mb-2">
            <Form.Label className="text-darker-grey text-start">{translation('manager.withdrawal.password')}:</Form.Label>
            <Form.Control type={showPassword ? "text" : "password"} placeholder={translation('manager.withdrawal.password')} {...registerPassword("password", { required: true })}/>
            <span className="eye-password-icon-modal">
              {
                showPassword ? (
                  <MdOutlineVisibility style={{ width: "22px", height: "22px", color: colors.greyscale.dark_grey }} onClick={() => setShowPassword(false)} />
                ) : (
                  <MdOutlineVisibilityOff style={{ width: "22px", height: "22px", color: colors.greyscale.dark_grey }} onClick={() => setShowPassword(true)} />
                )
              }
            </span>
            {errorsPassword.password ? (<div className="w-100"> <Error>{errorsPassword.password?.message}</Error> </div>) : ""}
          </Form.Group>
        </Form>
      </Modal>
    </Container>
  )
}